import { Button, Checkbox } from '@timelyapp/react';
import DropdownList from 'components/DropdownList';
import DropdownListItem from 'components/DropdownListItem';
import { Cog } from 'components/Icons';
import Popover from 'components/popovers/Popover';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setUsersDashboardIncludePlannedTime,
  setUsersDashboardIncludeTaskedTime,
} from 'redux/modules/users-page/users-dashboard/usersDashboard.actions';
import { getDashboardPreferences } from 'redux/modules/users-page/users-dashboard/usersDashboard.selectors';
import type { ThunkDispatch } from 'types/redux';

type Props = {};

const UsersDashboardPreferencesDropdown: React.FC<Props> = () => {
  const preferences = useSelector(getDashboardPreferences);
  const dispatch = useDispatch<ThunkDispatch>();
  const handleTogglePlannedTime = useCallback(
    () => dispatch(setUsersDashboardIncludePlannedTime(!preferences.includePlannedTime)),
    [preferences.includePlannedTime, dispatch]
  );
  const handleToggleTaskedTime = useCallback(
    () => dispatch(setUsersDashboardIncludeTaskedTime(!preferences.includeTaskedTime)),
    [preferences.includeTaskedTime, dispatch]
  );

  return (
    <Popover
      position="bottom-end"
      customScrollbars
      maxHeight="100vh"
      targetCaret={false}
      target={
        <Button priority="medium" size="small">
          <Cog style={{ width: 14, height: 14 }} />
        </Button>
      }
    >
      <DropdownList>
        <DropdownListItem onClick={handleTogglePlannedTime}>
          <Checkbox
            id="toggle-planned-time-in-summaries"
            onChangeChecked={handleTogglePlannedTime}
            checked={preferences.includePlannedTime}
            label="Include planned time"
          />
        </DropdownListItem>
        <DropdownListItem onClick={handleToggleTaskedTime}>
          <Checkbox
            id="toggle-tasked-time-in-summaries"
            onChangeChecked={handleToggleTaskedTime}
            checked={preferences.includeTaskedTime}
            label="Include assigned task"
          />
        </DropdownListItem>
      </DropdownList>
    </Popover>
  );
};
export default UsersDashboardPreferencesDropdown;
